module.exports = {
  hasEnoughToGuess: require('./has-enough-to-guess'),
  guessMap: require('./guess-map'),
  getWeightFromShape: require('./get-weight-from-shape'),
  getMethodProperties: require('./get-method-properties')
};
